const ComingSoonRibbon = () => {
  return (
    <div className="absolute top-0 right-0 border-l border-b border-secondary border-t-0 border-r-0 rounded-tr-md bg-primary text-secondary text-sm font-bold py-1 px-2">
      Coming Soon
    </div>
  )
}

export default ComingSoonRibbon
